<template>
  <div class="rr-training">
    <div class="rr-training__header" v-if="providerId">
      <div class="rr-training__source">
        <div
          class="rr-training__source-icon"
          :style="'background-image: url(' + providerImg + ')'"
        >
        </div>
        <div class="rr-training__source-name">{{ providerName }}</div>
      </div>
      <div class="rr-training__details">
        <slot name="details">
          <Link
            v-if="providerId === 'strava' && activityId"
            variant="secondary"
            size="xs"
            text="Cм. на Strava"
            :href="`https://www.strava.com/activities/${activityId}`"
            target="_blank"
          ></Link>
        </slot>
      </div>
    </div>
    <div class="rr-training__body">
      <div class="rr-training__body-item" v-if="$slots.before">
        <slot name="before"></slot>
      </div>
      <div class="rr-training__body-item">
        <div class="rr-training__metrics">
          <div
            class="rr-training__metrics-item"
            v-for="(item, i) in metrics"
            :key="i">
              <Metric
                class="rr-training__metric"
                :value="item.value"
                :units="item.units"
                :subtitle="item.name"
              >
              </Metric>
          </div>
        </div>
      </div>
      <div class="rr-training__body-item" v-if="$slots.after">
        <slot name="after"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import providers from '@rr-component-library/common/src/js/tracker-providers';
import Link from '@rr-component-library/link/src/main';
import Metric from '@rr-component-library/metric/src/main';

export default {
  name: 'Training',
  designVersion: '1.1.1',
  components: {
    Link,
    Metric,
  },
  props: {
    /**
     * Id провайдера
     */
    id: String,
    /**
     * Название провайдера
     */
    name: String,
    /**
     * Картинка провайдера
     */
    img: String,
    /**
     * Провайдер.<br>
     * Устанавливает id, name и img для выбранного провайдера
     */
    provider: {
      type: String,
      validator(value) {
        return ['', 'googlefit', 'strava', 'polar', 'garmin', 'fitbit', 'nike', 'runkeeper', 'runtastik', 'suunto', 'scounttracker', 'simplerun', 'scounthealth'].indexOf(value) !== -1;
      },
    },
    /**
     * Метрики
     */
    metrics: {
      type: Array,
      default: () => [],
    },
    /**
     * Id тренировки
     */
    activityId: {
      type: String,
    },
  },
  computed: {
    providerData() {
      return this.provider && providers[this.provider];
    },
    providerId() {
      return this.id || this.provider;
    },
    providerImg() {
      return this.img || (this.providerData && this.providerData.img);
    },
    providerName() {
      return this.name || (this.providerData && this.providerData.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Training";
</style>
